/**
 * 小部件之间的通信机制，依赖于工作桌面的依赖关系配置
 */

import { getTopWindow } from './window';

let top = getTopWindow(),
    // let top = window.top,
    // messageRelation = { test1: ['test2', 'test3'] },
    messageRelation = {};

export function setMessageRelation(relation) {
    messageRelation = relation;
}

export function getMessageRelation() {
    return messageRelation;
}

/**
 * @param {string} sendID 发送消息的小部件的id
 * @param {*} message 
 */
export function sendMessage(sendID, message) {
    const resMessage = { id: sendID, message };
    // 序列化，避免传过来的message是不可克隆对象导致postmessage报错
    getTopWindow().postMessage(JSON.parse(JSON.stringify(resMessage)));
}

/**
 * @param {string} receiveID 接收消息的小部件的id
 * @param {function} callback 
 */
export function receiveMessage(receiveID, callback) {
    let type = 'message';
    function messageListener(event) {
        let { data, currentTarget } = event;
        if (currentTarget === top) {
            if (messageRelation[data.id] === receiveID || messageRelation[data.id]?.includes(receiveID)) {
                callback?.(data.id, data.message);
            }
        }
    }

    getTopWindow().addEventListener(type, messageListener);

    return function () {
        getTopWindow().removeEventListener(type, messageListener);
    };
}

// receiveMessage('test1', function (id, message) {
//     console.log(id, message);
// });

// sendMessage('test2', { type: 'liyxt1', data: { x: 1 } });
// sendMessage('test3', { type: 'liyxt2', data: { x: 2 } });
// sendMessage('test2', { type: 'liyxt3', data: { x: 3 } });